var map = {
	"./Sample.jpg": "58da",
	"./logo-black.png": "3320",
	"./logo-white.png": "f19c",
	"./news-feeds/bbc.png": "5444",
	"./news-feeds/cnn.png": "56ff",
	"./news-feeds/sky.png": "552f",
	"./nr-logo.png": "b3de",
	"./scala-bang.png": "973b",
	"./scala-logo.png": "e8a5",
	"./template-priorities/high.png": "4136",
	"./template-priorities/low.png": "c1cf",
	"./template-priorities/medium.png": "8e95",
	"./template-types/engineering-landscape.jpg": "eb34",
	"./template-types/engineering-portrait.jpg": "dc52",
	"./template-types/incident-landscape.jpg": "91b7",
	"./template-types/incident-portrait.jpg": "5edc",
	"./template-types/information-landscape.jpg": "c3d1",
	"./template-types/information-portrait.jpg": "43dc",
	"./templates/engineering.png": "d6c2",
	"./templates/incident.png": "c598",
	"./templates/information.png": "ef2d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95cd";